export default __webpack_public_path__ + "static/dinos-de915668462815d8adad53bbcbdc4e0d.jpeg";